import { ICmsContentService } from '../icms-content.service';
import { NICmsContentPageType } from '../interfaces/icms-content-page-type.interfaces';

ICmsContentService.registerPageType({
    id: NICmsContentPageType.defaultPageTypeId,
    title: 'Standard page',
    fields: []
});
